


var searchApp = new Vue({
  el: '#shareForm',
  data () {
    return {
      showAllPages: false,

      loading: false,
      submitted: false,

      countrySearch: '',
      allCountires: newsCountriesCollection,

      firstName: '',
      lastName: '',
      country: '',
      organisation: '',
      email: '',

      type_of_content: '',

      submission_country: '',

      description: '',

      topics: [],
      news_title: '',
      news_author: '',

      event_name: '',
      event_date: '',
      event_location: '',

      assetItem_1: '',
      assetItem_2: '',
      assetItem_3: '',
      assetItem_4: '',
      assetItem_5: '',

      pageNumber: 0,
      resources: 1,

      selected_strings: contentStrings[0],
      strings: contentStrings
    }
  },
  created () {},
  mounted () {},
  methods: {
    nextPage() {
      this.pageNumber++

      setTimeout(() => {
          $('.tipme').tooltip()
        }, 1000);
    },
    prevPage() {
      this.pageNumber--
    },
    addResource() {
      if(this.resources <= 5) {
        this.resources++
      }
    },
    setStrings() {
      if (this.type_of_content == "Country progress update") {
        this.selected_strings = this.strings[0]
      } else if (this.type_of_content ==  "News story or blog post") {
        this.selected_strings = this.strings[1]
      } else if (this.type_of_content == "Event promotion or summary") {
        this.selected_strings = this.strings[2]
      } else {
        this.selected_strings = this.strings[3]
      }
    },
    submitForm () {
      if (this.progressUpdateComplete) {
          this.loading = true
          var the_form = $('.share-form form');
          
          // var formData = $(the_form).serialize();

          var formData = new FormData(the_form[0]);
          if (this.assetItem_1 != '') {
            var imagefile1 = document.querySelector('#resource_1');
            formData.append("image", imagefile1.files[0]);
          }
          if (this.assetItem_2 != '') {
            var imagefile2 = document.querySelector('#resource_2');
            formData.append("image", imagefile2.files[0]);
          }
          if (this.assetItem_3 != '') {
            var imagefile3 = document.querySelector('#resource_3');
            formData.append("image", imagefile3.files[0]);
          }
          if (this.assetItem_4 != '') {
            var imagefile4 = document.querySelector('#resource_4');
            formData.append("image", imagefile4.files[0]);
          }
          if (this.assetItem_5 != '') {
            var imagefile5 = document.querySelector('#resource_5');
            formData.append("image", imagefile5.files[0]);
          }


          
          window.axios({
              headers: { 
                'X-CSRF-TOKEN': $('input[name="_token"]').val()
              },
              method: 'post',
              url: $(the_form).attr('action'),
              data: formData
          }).then(response  => {
              console.log(response)
              this.loading = false
              this.submitted = true
          }).catch(error => {
              this.submitted = false
              console.log("Oops. Something broke.")
              console.log(error)
          });
      }
    },
    validEmail: function (email) {
      if ( email ) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email)
      } else {
        return false
      }
    }
  },
  watch: {
    type_of_content() {
      this.setStrings()
    } 
  },
  computed: {
    filteredCountries () {
      const search = this.countrySearch;
      let allItmes = []
      if (search.length > 0) {
        allItmes =  this.allCountires.filter(obj => Object.values(obj).some(val => val.includes(search)));
      } else {
        allItmes =  this.allCountires
      }
      return allItmes.sort((a,b) => (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0));
    },
    userDetailsComplete() {
      return this.firstName !== '' && this.country !== '' && this.organisation !== '' && this.validEmail(this.email)
    },
    contentTypeComplete() {
      return this.type_of_content !== ''
    },
    countrtyComplete() {
      return this.submission_country !== ''
    },
    progressUpdateComplete() {
      let discriptionFilled = this.description !== ''
      let topicSelected = this.topics.length > 0
      let firstAssetFilled = true
      // let firstAssetFilled = this.assetItem_1 !== ''
      let newsTitleFilled = this.news_title !== ''
      let newsAuthorFilled = this.news_author !== ''

      if (this.type_of_content == "Country progress update") {
        return discriptionFilled && firstAssetFilled

      } else if (this.type_of_content ==  "News story or blog post") {
        return firstAssetFilled && topicSelected

      } else if (this.type_of_content == "Event promotion or summary") {
        var eventName = this.event_name !== '';
        var eventDate = this.event_date !== '';
        return eventName && eventDate

      } else {
        return discriptionFilled && firstAssetFilled
      }

    },
  }
})